import { createContext, useContext } from 'react';

/**
 * Thème Mantine du site, celui du canvas. La sidebar vit sous le thème de
 * l'éditeur (teinte du mode) : un aperçu qui doit ressembler au site, comme
 * celui du bouton, y lit les valeurs par défaut que le canvas applique.
 */
const PuckSiteThemeContext = createContext(null);

export const PuckSiteThemeProvider = PuckSiteThemeContext.Provider;

export const usePuckSiteTheme = () => useContext(PuckSiteThemeContext);

/** Couleur principale du site : celle que Mantine donne aux composants sans
 *  couleur réglée (bouton, onglet…). */
export const sitePrimaryColor = (siteTheme) => siteTheme?.colors?.[siteTheme.primaryColor]?.[6];
